import { apiPost } from '@/services/api/client';
import { isoSecFromAny, nowIsoSec } from '@/lib/date';

export async function fetchHourRate(args: {
  shiftStartIso: string;
  mdType: string;
  facturationType: string;
}): Promise<string> {
  const billedAt = nowIsoSec();
  const body = await apiPost<{ value?: string }>(
    'hourRate',
    {
      shift_start: isoSecFromAny(args.shiftStartIso) || billedAt,
      md_type: args.mdType,
      billed_at: billedAt,
      facturation_type: args.facturationType,
    },
    { timeoutMs: 10_000 },
  );
  return body.value ?? '0';
}
